import { Component } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { Subscription } from 'rxjs';
import { environment } from '../../../../../environments/environment';
import { ModalResetPasswordComponent } from '../../modal-reset-password/modal-reset-password.component';

@Component({
  selector: 'app-modal-get-process-authorization',
  templateUrl: './modal-get-quote-process-authorization.component.html',
  styleUrls: ['./modal-get-quote-process-authorization.component.scss']
})
export class ModalGetQuoteProcessAuthorization {
  appUrl: string = environment.appUrl;
  loginDialogOpen = true;
  registrationDialogOpen = false;
  dialogRefAfterClosedSubscription: Subscription;

  constructor(
    private dialogRef: MatDialogRef<ModalGetQuoteProcessAuthorization>,
    private dialog: MatDialog
  ) {}

  ngOnInit() {}

  onResetPasswordDialog() {
    this.loginDialogOpen = false;
    const dialogRef = this.dialog.open(ModalResetPasswordComponent, {
      width: '400px',
      data: 'Data'
    });

    dialogRef.afterClosed().subscribe(() => {
      console.log('Reset password dialog was closed');
      this.dialogRef.close();
    });
  }

  onLoginSuccess() {
    this.dialogRef.close();
  }

  onCreateANewAccount() {
    this.loginDialogOpen = false;
    this.registrationDialogOpen = true;
  }

  onUserUpdate() {
    this.dialogRef.close();
  }

  onUserRegister() {
    this.loginDialogOpen = true;
    this.registrationDialogOpen = false;
  }

  closeDialog() {
    this.dialogRef.close();
  }

  ngOnDestroy() {
    if (this.dialogRefAfterClosedSubscription) this.dialogRefAfterClosedSubscription.unsubscribe();
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/modals/modal-get-quote/modal-get-quote-process-authorization/modal-get-quote-process-authorization.component.ts